@if (updateAvailable()) {
<div
  class="fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-4 border-b border-primary/20 bg-primary px-4 py-3 text-primary-foreground shadow"
  role="status"
  aria-live="polite">
  <p class="text-sm font-medium">A new version of SHOUT is available.</p>
  <button
    type="button"
    class="rounded-md bg-white px-3 py-1.5 text-sm font-semibold text-zinc-900 hover:bg-white/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
    (click)="reload()">
    Reload
  </button>
</div>
}
